export const addFloats = (
  str1: string,
  str2: string,
  precision = 2,
): number => {
  const num1 = Number(str1);
  const num2 = Number(str2);

  if (Number.isNaN(num1) || Number.isNaN(num2)) {
    throw new Error(
      'Invalid input: Both arguments must be convertible to numbers.',
    );
  }

  const sum = num1 + num2;
  return parseFloat(sum.toFixed(precision));
};

export const toFixedFloat = (num: number | undefined): string => {
  if (typeof num === 'number' && !Number.isNaN(num)) {
    return num.toFixed(2);
  } else {
    return '0.00';
  }
};

export const calculatePricesInCents = (
  finalPrice: number,
  quantity = 1,
  shippingPrice = 0,
) => {
  const qty = quantity <= 0 ? 1 : quantity;
  const unitPriceFloat = Number((finalPrice * 100) / qty).toFixed(2);
  const shipPriceFloat = Number(shippingPrice * 100).toFixed(2);
  const totalAmount =
    parseFloat(unitPriceFloat) * qty + parseFloat(shipPriceFloat);

  return {
    unitPrice: Math.floor(parseFloat(unitPriceFloat)),
    totalAmount,
  };
};

export const calculatePrices = (
  finalPrice: number,
  quantity: number = 1,
  shippingPrice: number = 0,
) => {
  const qty = quantity <= 0 ? 1 : quantity;
  const unitPrice = Number(Number((finalPrice * 100) / qty).toFixed(2));

  const totalAmount = Number(
    Number(unitPrice * Number(qty) + Number(shippingPrice) * 100).toFixed(0),
  );

  return {
    unitPrice,
    totalAmount,
  };
};
